import { connect } from 'react-redux';

//import { openDialog } from '../../../actions/Dialog';
//import { changeSupportPage, fetchItemsSupportPanel, showHideTicket } from '../../../actions/AdminPanel';

import SupportMyTickets from '../../../components/Support/SupportMyTickets/SupportMyTickets';
//import DialogConfirmationTicketWrapper from '../../DialogConfirmationTicketWrapper/DialogConfirmationTicketWrapper';

const mapStateToProps = (state) => {
    const isLoggedIn = !!state.currentAccount.spaId;
    return ({
        isLoggedIn: isLoggedIn,
        spaId: state.currentAccount.spaId,
        spaUsername: state.currentAccount.spaUsername,

        tickets: state.currentAccount.tickets,

        //isFetching: state.adminPanel.isFetching,
        //isError: state.adminPanel.isError,
    })
}

const mapDispatchToProps = (dispatch) => ({
    fetchItemsSupportPanel: (filterParams) => {
        //dispatch(fetchItemsSupportPanel(filterParams))
    },

    /*onClickFastAnswerTicket: (ticketId) => {
        dispatch(openDialog(<DialogConfirmationTicketWrapper id={ticketId} isFastAnswer={true} />))
    },
    onClickShowOrHiddenTicket: (ticketId, isClosed) => {
        dispatch(showHideTicket(ticketId, isClosed))
    },
    onClickDeleteTicket: (ticketId) => {
        dispatch(openDialog(<DialogConfirmationTicketWrapper id={ticketId} isFastAnswer={false} />))
    },*/

    onChangePage: (page, filterParams) => {
        /*Promise.resolve(
            dispatch(changeSupportPage(page))
        ).then(() => dispatch(fetchItemsSupportPanel(filterParams)))*/
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(SupportMyTickets)
